<template>
    <div :class="[$theme.baseText, $theme.contentBg]" class="pm-smart-treatment-item--header">
        <div class="pm-smart-treatment-item--header-region" :style="jaw==='upper' ? 'padding-bottom: 2px' : ''">
            <v-icon style="transition: all .3s;" :class="$theme.baseText" :style="jaw==='upper' ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)'">
                circle_slice_half
            </v-icon>
        </div>
        <div class="pm-smart-treatment-item--header-region-text">
            <span v-show="jawRange[0] > 0" class="roboto">{{ Helper.getToothNotation(jawRange[0]) }}
                <template v-if="jawRange[0] != jawRange[1]">-{{ Helper.getToothNotation(jawRange[1]) }}</template>
            </span>
        </div>
        <div class="pm-smart-treatment-item--header-title roboto">
            {{ title }}
        </div>
        <pm-price v-show="showPrice" style="flex-grow: 0; flex-shrink: 0; padding-right: 16px;" class="bold--text roboto f14 pm-smart-treatment-item--header-price" :class="$theme.baseText" :value="$store.state.simplePlan[jaw+'JawTotal']" />
    </div>
</template>

<style lang="scss">
    .pm-smart-treatment-item--header {
        position: relative;
        height: 52px;
        display: flex;
        align-items: center;
        transition: all .4s;
        width: 100%;
        justify-content: space-between;
        box-shadow: inset 0 8px 15px rgba(0,0,0,.03), 0 8px 15px rgba(0,0,0,.03);

        .pm-smart-treatment-item--header-region {
            margin-top: -2px;
            padding-left: 14px;
            width: 48px;
            text-align: center;
            flex-grow: 0;
            flex-shrink: 0;
        }
    }

    .pm-smart-treatment-item--header-region-text {
        width: 44px;
        white-space: nowrap;
        flex-shrink: 0;
        flex-grow: 0;
        font-size: 13px;
    }

    .pm-smart-treatment-item--header-region-text span {
        white-space: nowrap;
        display: inline-block;
        padding: 0 0 0 4px;
        font-weight: 600;
    }

    .pm-smart-treatment-item--header-title {
        flex-grow: 1;
        padding-left: 16px;
        padding-right: 8px;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 600;
    }




@media (min-width: 700px) {
    .pm-smart-treatment-item--header-price,
    .pm-smart-treatment-item--header-title {
        font-size: 18px;
        margin-left: 8px;
    }

    .pm-smart-treatment-item--header {
        height: 52px !important;
        /* INFO: disabled temporary */
        /* margin-bottom: 10px; */
    }

    .pm-smart-treatment-item--header-region + div span {
        font-size: 18px;
        margin-top: 4px;
    }

    .pm-smart-treatment-item--header-region i {
        font-size: 26px;
        font-weight: 500;
        margin-top: 4px;
    }

    .pm-smart-treatment-item--header-region+div span {
        font-size: 18px !important;
        margin-top: 0 !important;
        padding-left: 8px !important;
    }
}
</style>

<script>
import PlanSimpleService from "../../extensions/services/plan-simple-service";
export default {
    props: {
        jaw: {
            type: String,
            default: "",
        },
        showPrice: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        title() {
            const tpl = this.$store.state.simplePlan[this.jaw + "Tpl"];
            if (typeof tpl !== "undefined" && tpl !== null) return this.$t("plan_simple.template_"+tpl.title);

            const titles = [];
            const primaryTreatments = PlanSimpleService.getPrimaryStepsForJaw(this.jaw);
            if (primaryTreatments.stateIds.length === 0) {
                return "";
            }

            const ids = primaryTreatments.stateIds;

            if (ids.includes(26)) titles.unshift(this.$t("plan_calculator.state_26"));
            if (ids.includes(9) && ids.includes(15)) titles.push(this.$t("plan_calculator.state_9") + "/" + this.$t("plan_calculator.state_15"));
            else if (ids.includes(9)) titles.push(this.$t("plan_calculator.state_9"));
            else if (ids.includes(15)) titles.push(this.$t("plan_calculator.state_15"));
            if (ids.includes(11)) titles.push(this.$t("plan_calculator.state_11"));
            return titles.join(" + ");
        },
        jawRange() {
            return PlanSimpleService.getJawRange(this.jaw);
        },
    },
};
</script>
